export default "__VITE_ASSET__c0T3LDcB__"